/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type EmailSubscriptionSettings_session$ref = any;
export type routePropsSubscriptionsEmail_QueryVariables = {||};
export type routePropsSubscriptionsEmail_QueryResponse = {|
  +my_portal_session: ?{|
    +id: string,
    +$fragmentRefs: EmailSubscriptionSettings_session$ref,
  |}
|};
export type routePropsSubscriptionsEmail_Query = {|
  variables: routePropsSubscriptionsEmail_QueryVariables,
  response: routePropsSubscriptionsEmail_QueryResponse,
|};
*/


/*
query routePropsSubscriptionsEmail_Query {
  my_portal_session {
    id
    ...EmailSubscriptionSettings_session
  }
}

fragment EmailSubscriptionSettings_session on MyPortal__Session {
  id
  portal_person {
    id
    email_subscription_settings {
      id
      global_unsubscribed
      job_notifications_enabled
      job_notifications {
        id
        enabled
        frequency
      }
      ...JobNotificationList_email_subscription_settings
    }
  }
  label_global_messages_successfully_saved: i18n(key: "global.messages.successfully_saved")
  label_global_busy_saving: i18n(key: "global.busy.saving")
  email_subscriptions_page_heading: i18n_config_t(key: "myportal.config.subscriptions.email.page_heading")
  email_subscriptions_page_description: i18n_config_t(key: "myportal.config.subscriptions.email.page_description")
  toggle_all_email_subscriptions_label: i18n_config_t(key: "myportal.config.subscriptions.email.toggle_all_email_subscriptions_label")
  toggle_all_email_subscriptions_description: i18n_config_t(key: "myportal.config.subscriptions.email.toggle_all_email_subscriptions_description")
  toggle_email_direct_from_recruiter_label: i18n_config_t(key: "myportal.config.subscriptions.email.toggle_email_direct_from_recruiter_label")
  toggle_email_direct_from_recruiter_description: i18n_config_t(key: "myportal.config.subscriptions.email.toggle_email_direct_from_recruiter_description")
  toggle_email_bulk_updates_label: i18n_config_t(key: "myportal.config.subscriptions.email.toggle_email_bulk_updates_label")
  toggle_email_bulk_updates_description: i18n_config_t(key: "myportal.config.subscriptions.email.toggle_email_bulk_updates_description")
  toggle_email_job_notifications_label: i18n_config_t(key: "myportal.config.subscriptions.email.toggle_email_job_notifications_label")
  toggle_email_job_notifications_description: i18n_config_t(key: "myportal.config.subscriptions.email.toggle_email_job_notifications_description")
  button_update_subscriptions: i18n_config_t(key: "myportal.config.subscriptions.email.button_update_subscriptions")
  button_unsubscribe_all: i18n_config_t(key: "myportal.config.subscriptions.email.button_unsubscribe_all")
}

fragment JobNotificationList_email_subscription_settings on MyPortal__EmailSubscriptionSettings {
  id
  job_notifications_enabled
  job_notifications {
    id
    enabled
    ...JobNotification_job_notification
  }
}

fragment JobNotification_job_notification on MyPortal__JobNotificationEmailSubscription {
  id
  enabled
  frequency_values {
    value
    label
  }
  frequency
  title
  last_sent_ago
  last_sent_at
  created_at
  expiring_soon
  created_ago
  url
  frequency_label: i18n(key: "myportal.client.subscriptions.email.job_notifications.frequency")
  last_sent_ago_label: i18n(key: "myportal.client.subscriptions.email.job_notifications.last_sent_ago_label")
  created_ago_label: i18n(key: "myportal.client.subscriptions.email.job_notifications.created_ago_label")
  view_results_label: i18n(key: "myportal.client.subscriptions.email.job_notifications.view_results_label")
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "routePropsSubscriptionsEmail_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MyPortal__Session",
        "kind": "LinkedField",
        "name": "my_portal_session",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "EmailSubscriptionSettings_session"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "QueryRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "routePropsSubscriptionsEmail_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MyPortal__Session",
        "kind": "LinkedField",
        "name": "my_portal_session",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "MyPortal__PortalPerson",
            "kind": "LinkedField",
            "name": "portal_person",
            "plural": false,
            "selections": [
              (v0/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MyPortal__EmailSubscriptionSettings",
                "kind": "LinkedField",
                "name": "email_subscription_settings",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "global_unsubscribed",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "job_notifications_enabled",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MyPortal__JobNotificationEmailSubscription",
                    "kind": "LinkedField",
                    "name": "job_notifications",
                    "plural": true,
                    "selections": [
                      (v0/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "enabled",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "frequency",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "MyPortal__JobNotificationFrequencyValue",
                        "kind": "LinkedField",
                        "name": "frequency_values",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "value",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "label",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "last_sent_ago",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "last_sent_at",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "created_at",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "expiring_soon",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "created_ago",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                      },
                      {
                        "alias": "frequency_label",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "key",
                            "value": "myportal.client.subscriptions.email.job_notifications.frequency"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "i18n",
                        "storageKey": "i18n(key:\"myportal.client.subscriptions.email.job_notifications.frequency\")"
                      },
                      {
                        "alias": "last_sent_ago_label",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "key",
                            "value": "myportal.client.subscriptions.email.job_notifications.last_sent_ago_label"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "i18n",
                        "storageKey": "i18n(key:\"myportal.client.subscriptions.email.job_notifications.last_sent_ago_label\")"
                      },
                      {
                        "alias": "created_ago_label",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "key",
                            "value": "myportal.client.subscriptions.email.job_notifications.created_ago_label"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "i18n",
                        "storageKey": "i18n(key:\"myportal.client.subscriptions.email.job_notifications.created_ago_label\")"
                      },
                      {
                        "alias": "view_results_label",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "key",
                            "value": "myportal.client.subscriptions.email.job_notifications.view_results_label"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "i18n",
                        "storageKey": "i18n(key:\"myportal.client.subscriptions.email.job_notifications.view_results_label\")"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": "label_global_messages_successfully_saved",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "global.messages.successfully_saved"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n",
            "storageKey": "i18n(key:\"global.messages.successfully_saved\")"
          },
          {
            "alias": "label_global_busy_saving",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "global.busy.saving"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n",
            "storageKey": "i18n(key:\"global.busy.saving\")"
          },
          {
            "alias": "email_subscriptions_page_heading",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.subscriptions.email.page_heading"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.subscriptions.email.page_heading\")"
          },
          {
            "alias": "email_subscriptions_page_description",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.subscriptions.email.page_description"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.subscriptions.email.page_description\")"
          },
          {
            "alias": "toggle_all_email_subscriptions_label",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.subscriptions.email.toggle_all_email_subscriptions_label"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.subscriptions.email.toggle_all_email_subscriptions_label\")"
          },
          {
            "alias": "toggle_all_email_subscriptions_description",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.subscriptions.email.toggle_all_email_subscriptions_description"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.subscriptions.email.toggle_all_email_subscriptions_description\")"
          },
          {
            "alias": "toggle_email_direct_from_recruiter_label",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.subscriptions.email.toggle_email_direct_from_recruiter_label"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.subscriptions.email.toggle_email_direct_from_recruiter_label\")"
          },
          {
            "alias": "toggle_email_direct_from_recruiter_description",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.subscriptions.email.toggle_email_direct_from_recruiter_description"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.subscriptions.email.toggle_email_direct_from_recruiter_description\")"
          },
          {
            "alias": "toggle_email_bulk_updates_label",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.subscriptions.email.toggle_email_bulk_updates_label"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.subscriptions.email.toggle_email_bulk_updates_label\")"
          },
          {
            "alias": "toggle_email_bulk_updates_description",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.subscriptions.email.toggle_email_bulk_updates_description"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.subscriptions.email.toggle_email_bulk_updates_description\")"
          },
          {
            "alias": "toggle_email_job_notifications_label",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.subscriptions.email.toggle_email_job_notifications_label"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.subscriptions.email.toggle_email_job_notifications_label\")"
          },
          {
            "alias": "toggle_email_job_notifications_description",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.subscriptions.email.toggle_email_job_notifications_description"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.subscriptions.email.toggle_email_job_notifications_description\")"
          },
          {
            "alias": "button_update_subscriptions",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.subscriptions.email.button_update_subscriptions"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.subscriptions.email.button_update_subscriptions\")"
          },
          {
            "alias": "button_unsubscribe_all",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "myportal.config.subscriptions.email.button_unsubscribe_all"
              }
            ],
            "kind": "ScalarField",
            "name": "i18n_config_t",
            "storageKey": "i18n_config_t(key:\"myportal.config.subscriptions.email.button_unsubscribe_all\")"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "33a71f8817128019c69b7a01c49161a3",
    "id": null,
    "metadata": {},
    "name": "routePropsSubscriptionsEmail_Query",
    "operationKind": "query",
    "text": "query routePropsSubscriptionsEmail_Query {\n  my_portal_session {\n    id\n    ...EmailSubscriptionSettings_session\n  }\n}\n\nfragment EmailSubscriptionSettings_session on MyPortal__Session {\n  id\n  portal_person {\n    id\n    email_subscription_settings {\n      id\n      global_unsubscribed\n      job_notifications_enabled\n      job_notifications {\n        id\n        enabled\n        frequency\n      }\n      ...JobNotificationList_email_subscription_settings\n    }\n  }\n  label_global_messages_successfully_saved: i18n(key: \"global.messages.successfully_saved\")\n  label_global_busy_saving: i18n(key: \"global.busy.saving\")\n  email_subscriptions_page_heading: i18n_config_t(key: \"myportal.config.subscriptions.email.page_heading\")\n  email_subscriptions_page_description: i18n_config_t(key: \"myportal.config.subscriptions.email.page_description\")\n  toggle_all_email_subscriptions_label: i18n_config_t(key: \"myportal.config.subscriptions.email.toggle_all_email_subscriptions_label\")\n  toggle_all_email_subscriptions_description: i18n_config_t(key: \"myportal.config.subscriptions.email.toggle_all_email_subscriptions_description\")\n  toggle_email_direct_from_recruiter_label: i18n_config_t(key: \"myportal.config.subscriptions.email.toggle_email_direct_from_recruiter_label\")\n  toggle_email_direct_from_recruiter_description: i18n_config_t(key: \"myportal.config.subscriptions.email.toggle_email_direct_from_recruiter_description\")\n  toggle_email_bulk_updates_label: i18n_config_t(key: \"myportal.config.subscriptions.email.toggle_email_bulk_updates_label\")\n  toggle_email_bulk_updates_description: i18n_config_t(key: \"myportal.config.subscriptions.email.toggle_email_bulk_updates_description\")\n  toggle_email_job_notifications_label: i18n_config_t(key: \"myportal.config.subscriptions.email.toggle_email_job_notifications_label\")\n  toggle_email_job_notifications_description: i18n_config_t(key: \"myportal.config.subscriptions.email.toggle_email_job_notifications_description\")\n  button_update_subscriptions: i18n_config_t(key: \"myportal.config.subscriptions.email.button_update_subscriptions\")\n  button_unsubscribe_all: i18n_config_t(key: \"myportal.config.subscriptions.email.button_unsubscribe_all\")\n}\n\nfragment JobNotificationList_email_subscription_settings on MyPortal__EmailSubscriptionSettings {\n  id\n  job_notifications_enabled\n  job_notifications {\n    id\n    enabled\n    ...JobNotification_job_notification\n  }\n}\n\nfragment JobNotification_job_notification on MyPortal__JobNotificationEmailSubscription {\n  id\n  enabled\n  frequency_values {\n    value\n    label\n  }\n  frequency\n  title\n  last_sent_ago\n  last_sent_at\n  created_at\n  expiring_soon\n  created_ago\n  url\n  frequency_label: i18n(key: \"myportal.client.subscriptions.email.job_notifications.frequency\")\n  last_sent_ago_label: i18n(key: \"myportal.client.subscriptions.email.job_notifications.last_sent_ago_label\")\n  created_ago_label: i18n(key: \"myportal.client.subscriptions.email.job_notifications.created_ago_label\")\n  view_results_label: i18n(key: \"myportal.client.subscriptions.email.job_notifications.view_results_label\")\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '751c302e6903676eacb9b9cb68b8d9cc';

module.exports = node;
